<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>

    <div v-show="!modoEdicao">
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Abertura</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="setEdicao(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                </tr></tbody>
            </table></div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
        <div v-else>
            <EmptyStateComponent
                title="Nenhuma ordem se serviço aguardando execução"
                message="Todas as ordens de serviço lançadas possuem registro de execução."
            />
        </div>

        <div class="row-space"></div>
        <div class="row-end">
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>


    <div v-if="modoEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item info-card">
                    <span>Dados</span>
                    <strong>OS {{ Funcoes.formatInteger(osView.cdos) }} - {{ osView.nmos }}</strong>
                </div>
                
                <div class="form-item info-card">
                    <span>Equipamento/Veículo</span>
                    <strong>{{ osView.nmequipamento }} · Placa {{ osView.placa }}</strong>
                </div>
            
                <div class="form-item-char20 info-card info-card--highlight">
                    <span>Data Solicitação</span>
                    <strong class="center">{{ Funcoes.formatDateFromJson(osView.dtabertura) }}</strong>
                </div>
            </div>
            
            <div class="row">
                <div class="form-item info-card">
                    <span>Fornecedor</span>
                    <strong>{{ osView.nmfornecedor }}</strong>
                </div>
            
                <div class="form-item-char20 info-card info-card--highlight">
                    <span>Valor Orçamento</span>
                    <strong class="right">R$ {{ Funcoes.formatDecimal(osView.orcamento_valor) }}</strong>
                </div>
            
                <div class="form-item-char20 info-card info-card--highlight">
                    <span>Valor Aprovado</span>
                    <strong class="right">R$ {{ Funcoes.formatDecimal(osView.aprovacao_valor) }}</strong>
                </div>
            </div>
        </div>

        <div class="form-edit-page">
            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <input type="date" v-model="payloadOs.execucao_data" />
                </div>

                <div class="form-item-char15">
                    <label class="label-caption">Nro Doc</label>
                    <input type="text" class="input-right" v-model="payloadOs.execucao_nrodoc" v-number maxlength="9" />
                </div>
                
                <div class="form-item-data">
                    <label class="label-caption">Data Doc</label>
                    <input type="date" v-model="payloadOs.execucao_dtdoc" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Execução (R$)</label>
                    <input type="text" class="input-right" v-model="payloadOs.execucao_valor" v-decimal maxlength="15" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Km/Horas</label>
                    <input type="text" class="input-right" v-model="payloadOs.execucao_kmhoras" v-decimal maxlength="15" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Informações</label>
                    <input type="text" v-model="payloadOs.execucao_informacoes" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <AnexoUploadField
                        ref="uploaderRef"
                        :label="'Anexar NF:'"
                        :maxSizeMB="20"
                    />
                </div>
            </div>


            <div class="servicos-checklist row-space">
                <div class="servicos-checklist-header">
                    <div>
                        <strong>Verificação dos serviços executados</strong>
                        <span>Marque os serviços que foram efetivamente executados.</span>
                    </div>

                    <div class="servicos-checklist-count">
                        {{ totalServicosExecutados }} / {{ lsItensServico.length }}
                    </div>
                </div>

                <div
                    v-for="(item, index) in lsItensServico"
                    :key="item.id"
                    class="servico-check-item"
                    :class="{ 'servico-check-item--checked': item.ckexecutado === 'S' }"
                >
                    <div class="servico-check-info">
                        <span class="servico-check-codigo">
                            Serviço {{ item.cdservico || item.ordem || index + 1 }}
                        </span>

                        <strong>
                            {{ item.nmservico || item.descricao }}
                        </strong>
                    </div>

                    <label class="switch-check">
                        <input
                            type="checkbox"
                            :checked="item.ckexecutado === 'S'"
                            @change="item.ckexecutado = $event.target.checked ? 'S' : 'N'"
                        />
                        <span></span>
                    </label>
                </div>
            </div>


            <div class="row-end">
                <button class="btn-small" @click="abrirModalExecucao">Salvar</button>
                <button class="btn-small" @click="modoEdicao=false">Voltar</button>
            </div>
        </div>
    </div>
    

    <ConfirmModal ref="confirmModal" />
</template>

<script setup>
import { onMounted, reactive, ref, computed } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import AnexoUploadField from '@/components/fields/AnexoUploadField.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';

const emit = defineEmits(['close']);

const payloadOs = reactive({
    id: 0,
    execucao_idlogin: 0,
    execucao_data: '',
    execucao_nrodoc: 0,
    execucao_dtdoc: '',
    execucao_kmhoras: 0,
    execucao_valor: 0,
    execucao_informacoes: '',
    execucao_idanexo: 0,
    idlogin: 0
});


const confirmModal = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const lsItensServico = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const osView = ref({});

const uploaderRef = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const totalServicosExecutados = computed(() =>
    lsItensServico.value.filter(item => item.ckexecutado === 'S').length
);


async function abrirModalExecucao(){
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;

    const confirmado = await confirmModal.value.show({
        message: "Confirma execução da ordem de serviço?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){salvarExecucao()}
}


function closeForm() { emit('close'); }


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 7,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarExecucao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;


        if (uploaderRef.value?.hasFile()){
            const file = uploaderRef.value.getFile();
            const ext = (file.name.split('.').pop() || '').toLowerCase();
            const payloadAnexo = {
                idmunicipio: globalStore.idmunicipio,
                idlogin: globalStore.idlogin,
                tipo: file.type === 'application/pdf' ? '0' : '1',
                fname: file.name,
                file_ext: ext,
                mime_type: file.type || 'application/octet-stream'
            };
            const result = await uploaderRef.value.upload(payloadAnexo);
            payloadOs.execucao_idanexo = result.id;
        }


        // SALVAR SERVIÇOS EXECUTADOS
        const itensExecutados = lsItensServico.value.filter(
            item => item.ckexecutado === 'S'
        );

        for (const item of itensExecutados) {
            const r = await Api.genericPut('/cad/manut_os_item', {
                id: item.id,
                ckexecutado: 'S',
                idlogin: globalStore.idlogin
            });
            if (r.bolok != 1) throw new Error(r.erro);
        }


        // SALVAR DADOS DA EXECUÇÃO
        const payloadSalvarOs = {
            ...payloadOs,
            execucao_nrodoc: Funcoes.integerFromString(payloadOs.execucao_nrodoc),
            execucao_valor: Funcoes.decimalFromString(payloadOs.execucao_valor),
            execucao_kmhoras: Funcoes.decimalFromString(payloadOs.execucao_kmhoras),
            execucao_idanexo: payloadOs.execucao_idanexo || 0,
            execucao_idlogin: globalStore.idlogin,
            idlogin: globalStore.idlogin
        };

        const respOs = await Api.genericPut('/cad/manut_os', payloadSalvarOs);
        if (respOs.bolok != 1) throw new Error(respOs?.erro || 'Não foi possível gravar execução da OS');
        modoEdicao.value=false;
        await lerDados();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function setEdicao(obj) {
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        
        osView.value = obj;
        payloadOs.id = obj.id;
        payloadOs.execucao_data = null;
        payloadOs.execucao_dtdoc = null;
        payloadOs.execucao_idanexo = null;
        payloadOs.execucao_idlogin = globalStore.idlogin;
        payloadOs.execucao_informacoes = null;
        payloadOs.execucao_kmhoras = null;
        payloadOs.execucao_nrodoc = null;
        payloadOs.execucao_valor = null;
        payloadOs.idlogin = globalStore.idlogin;
        
        const itensServ = await Api.genericPost('/frota/manut_os/itens/servicos', {
            idmunicipio: globalStore.idmunicipio,
            idreferencia: obj.id});
        lsItensServico.value = itensServ;
        
        modoEdicao.value=true;
    }catch (error){
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{
        isLoading.value = false;
    }
}


async function startPage(){
    await lerDados();
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function validarDados(){
    let x = '';
    const nroDoc = Funcoes.integerFromString(payloadOs.execucao_nrodoc);
    const vlDoc = Funcoes.decimalFromString(payloadOs.execucao_valor);
    const kmHoras = Funcoes.decimalFromString(payloadOs.execucao_kmhoras);

    let r = Validar.data(payloadOs.execucao_data, -360, 'Data de execução');
    if (!r.ok) x += `\n-${r.msg}`;
    if (nroDoc <= 0) x += '\n-Informe valor do documento corretamente';
    r = Validar.data(payloadOs.execucao_dtdoc, -360, 'Data de emissão');
    if (vlDoc <= 0) x += '\n-Informe valor do documento corretamente';
    if (kmHoras <= 0) x += '\n-Informe qual KM ou Horas do veículo/equipamento';
    if (!r.ok) x += `\n-${r.msg}`;

    if (lsItensServico.value.length>0 && !lsItensServico.value.some(item => item.ckexecutado === 'S')) {
        x += '\n-Marque ao menos um serviço executado.';
    }
    
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}

onMounted(startPage);
</script>


<style scoped>
.servicos-checklist {
    border: 1px solid #d8dee9;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
}

.servicos-checklist-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    background: #f8fafc;
    border-bottom: 1px solid #d8dee9;
}

.servicos-checklist-header strong {
    display: block;
    color: #1f2937;
    font-size: 0.95rem;
}

.servicos-checklist-header span {
    display: block;
    margin-top: 2px;
    color: #64748b;
    font-size: 0.82rem;
}

.servicos-checklist-count {
    min-width: 72px;
    text-align: center;
    padding: 6px 10px;
    border-radius: 999px;
    background: #e5e7eb;
    color: #374151;
    font-weight: 700;
    font-size: 0.85rem;
}

.servico-check-item {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-bottom: 1px solid #eef2f7;
}

.servico-check-item:last-child {
    border-bottom: none;
}

.servico-check-item--checked {
    background: #f0fdf4;
}

.servico-check-info {
    min-width: 0;
}

.servico-check-codigo {
    display: block;
    color: #64748b;
    font-size: 0.75rem;
    margin-bottom: 3px;
}

.servico-check-info strong {
    display: block;
    color: #111827;
    font-size: 0.92rem;
    word-break: break-word;
}

.switch-check {
    position: relative;
    display: inline-block;
    width: 46px;
    height: 24px;
}

.switch-check input {
    opacity: 0;
    width: 0;
    height: 0;
}

.switch-check span {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background: #cbd5e1;
    border-radius: 999px;
    transition: 0.2s;
}

.switch-check span::before {
    content: "";
    position: absolute;
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background: #fff;
    border-radius: 50%;
    transition: 0.2s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.25);
}

.switch-check input:checked + span {
    background: #16a34a;
}

.switch-check input:checked + span::before {
    transform: translateX(22px);
}
</style>